import { z } from "zod";

export const BlockRuleCriteriaType = z.enum(["COUNTRY", "IP_ADDRESS"]);

export const BlockRuleType = z.enum(["INITIAL_CREDITS"]);

export const BlockRuleDto = z.object({
  externalId: z.string(),
  criteriaType: BlockRuleCriteriaType,
  value: z.string(),
  blockType: BlockRuleType,
  reason: z.string().nullable(),
  createdAt: z.string(),
});

export const CreateBlockRuleRequestDto = z.object({
  criteriaType: BlockRuleCriteriaType,
  value: z.string().min(1),
  blockType: BlockRuleType,
  reason: z.string().nullable().optional(),
});

export const ListBlockRulesResponseDto = z.object({
  rules: z.array(BlockRuleDto),
});

export const DeleteBlockRuleResponseDto = z.object({
  success: z.boolean(),
});

export type BlockRuleCriteriaType = z.infer<typeof BlockRuleCriteriaType>;
export type BlockRuleType = z.infer<typeof BlockRuleType>;
export type BlockRuleDto = z.infer<typeof BlockRuleDto>;
export type CreateBlockRuleRequestDto = z.infer<
  typeof CreateBlockRuleRequestDto
>;
export type ListBlockRulesResponseDto = z.infer<
  typeof ListBlockRulesResponseDto
>;
export type DeleteBlockRuleResponseDto = z.infer<
  typeof DeleteBlockRuleResponseDto
>;
